import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow: hidden;
  padding: 24px 16px;
`

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const InputWrapper = styled.div`
  width: 100%;
`

export const DropdownWrapper = styled.div`
  width: 100%;
`

export const KeyboardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: white;
  margin-top: auto;
`
